import React from 'react';
import { useSelector } from 'react-redux';

import { Newsfeed as EdenredUiNewsfeed, Box } from 'edenred-ui';

import paymentLimitsImg from '@epi-assets/images/Edenred-EMP-banner-payment-limits.jpg';
import delicardImg from '@epi-assets/images/Delicard-EMP-banner-summer.jpg';
import taxationImg from '@epi-assets/images/Edenred-EMP-banner-benefit-taxation.jpg';
import { homeBanner } from '@epi-helpers/homeBanner';
import { getApplicationLanguageId } from '@epi-store/application/application.selectors';

export function Newsfeed() {
  const language = useSelector(getApplicationLanguageId);
  const banners = homeBanner(paymentLimitsImg, delicardImg, taxationImg).filter(
    item => {
      return (
        item.content.locale === language &&
        (item.startDate ? item.startDate < new Date() : true) &&
        (item.endDate ? item.endDate > new Date() : true)
      );
    }
  );

  return (
    <Box mt={3} mx={-5}>
      <EdenredUiNewsfeed banners={banners} />
    </Box>
  );
}
